import {
    CommonAPI
} from "./common/Common.api";
import {
    UserAPI
} from "./users/User.api";
import {
    AuthAPI
} from "./Auth.api";
import {
    PollAPI
} from "./poll/Poll.api";
import {
    AudienceAPI
} from "./Audience.api";
import {
    ChannelAPI
} from "./ads/Channel.api";
import {
    AdGoalAPI
} from "./ads/AdGoal.api";
import {
    AdParameterAPI
} from "./ads/AdParameter.api";
import {
    AdPlacementTypeAPI
} from "./ads/AdPlacementType.api";
import {
    AdTypeAPI
} from "./ads/AdType.api";
import {
    InventoryAPI
} from "./inventory/Inventory.api";
import {
    AdPlacementAPI
} from "./inventory/AdPlacement.api";
import { CampaignAPI } from "./campaigns/Campaign.api";
import { AdKPIAPI } from "./ads/AdKPI.api";





export const UserAPIInstance = new UserAPI(process.env.VUE_APP_API)
export const CommonAPIInstance = new CommonAPI(process.env.VUE_APP_API)
export const AuthAPIInstance = new AuthAPI(process.env.VUE_APP_API)
export const PollAPIInstance = new PollAPI(process.env.VUE_APP_API)
export const AudienceAPIInstance = new AudienceAPI(process.env.VUE_APP_API)
export const ChannelAPIInstance = new ChannelAPI(process.env.VUE_APP_API)
export const AdGoalAPIInstance = new AdGoalAPI(process.env.VUE_APP_API)
export const AdParameterAPIInstance = new AdParameterAPI(process.env.VUE_APP_API)
export const AdPlacementTypeAPIInstance = new AdPlacementTypeAPI(process.env.VUE_APP_API)
export const AdTypeAPIInstance = new AdTypeAPI(process.env.VUE_APP_API)
export const InventoryAPIInstance = new InventoryAPI(process.env.VUE_APP_API);
export const AdPlacementAPIInstance = new AdPlacementAPI(process.env.VUE_APP_API);
export const CampaignAPIInstance = new CampaignAPI(process.env.VUE_APP_API);
export const AdKPIAPIInstance = new AdKPIAPI(process.env.VUE_APP_API);